module.exports = __webpack_public_path__ + "static/media/aprilfools.8da40513.png";